/**
 * @generated SignedSource<<74fbaa5bc476f54b0345d4792f028180>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EducationLevelSelectInput_query$data = {
  readonly educationLevels: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "EducationLevelSelectInput_query";
};
export type EducationLevelSelectInput_query$key = {
  readonly " $data"?: EducationLevelSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EducationLevelSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EducationLevelSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "EducationLevelConnection",
      "kind": "LinkedField",
      "name": "educationLevels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EducationLevel",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "educationLevels(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7041f806f4f09f6dfe1fa1e81d11c8af";

export default node;
